export function cleanObject(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            acc[key] = value;
        }
        return acc;
    }, {});
}

export const removeExistingData = (obj1, obj2) => {
    const diff = {};

    const compare = (key, val1, val2) => {
        if (typeof val1 === 'object' && !Array.isArray(val1) && val1 !== null) {
            const nestedDiff = removeExistingData(val1, val2 || {});
            if (Object.keys(nestedDiff).length > 0) {
                diff[key] = nestedDiff;
            }
        } else if (Array.isArray(val1)) {
            if (key === 'skills' && Array.isArray(val2)) {
                const val1Ids = val1.map(item => item._id);
                if (JSON.stringify(val1Ids) !== JSON.stringify(val2)) {
                    diff[key] = val2;
                }
            } else if (JSON.stringify(val1) !== JSON.stringify(val2)) {
                diff[key] = val2;
            }
        } else {
            if (val1 !== val2) {
                diff[key] = val2;
            }
        }
    };

    Object.keys(obj1).forEach(key => {
        compare(key, obj1[key], obj2[key]);
    });

    Object.keys(obj2).forEach(key => {
        if (!(key in obj1) && obj2[key] !== undefined) {
            diff[key] = obj2[key];
        }
    });

    return diff;
};